import React from 'react';
import { Avatar, Badge, Typography, TextField, InputAdornment, ToggleButton, ToggleButtonGroup } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Loading from '../../../components/loading/Loading';
import { FILTER_OPTIONS } from '../hooks/useChats';
import { formatPhoneNumber, getChatPreview, formatChatTimestamp, getChatKey, getSendTarget } from '../utils';
import styles from './ChatList.module.css';

/**
 * Coluna esquerda: busca, filtro Todos/Não lidas e a lista de conversas.
 */
const ChatList = ({
  chats,
  loading,
  selectedKey,
  onSelect,
  searchText,
  onSearchChange,
  filterOption,
  onFilterChange,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Buscar por nome ou telefone..."
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <ToggleButtonGroup
          value={filterOption}
          exclusive
          onChange={(e, value) => { if (value !== null) onFilterChange(value); }}
          size="small"
          fullWidth
          className={styles.filterGroup}
        >
          <ToggleButton value={FILTER_OPTIONS.ALL} className={styles.filterButton}>
            {FILTER_OPTIONS.ALL}
          </ToggleButton>
          <ToggleButton value={FILTER_OPTIONS.UNREAD} className={styles.filterButton}>
            {FILTER_OPTIONS.UNREAD}
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      <div className={styles.list}>
        {loading ? (
          <div className={styles.loadingWrapper}><Loading /></div>
        ) : chats.length === 0 ? (
          <Typography variant="body2" color="textSecondary" className={styles.emptyText}>
            Nenhuma conversa encontrada.
          </Typography>
        ) : (
          chats.map((chat) => {
            const chatKey = getChatKey(chat);
            const unreadCount = Number(chat.unreadCount) || 0;
            const isSelected = selectedKey === chatKey;

            return (
              <div
                key={chatKey}
                className={`${styles.chatItem} ${isSelected ? styles.chatItemSelected : ''}`}
                onClick={() => onSelect(chat)}
              >
                <Avatar src={chat.chatPhoto} alt={chat.chatName} sx={{ width: 44, height: 44 }} />
                <div className={styles.chatItemBody}>
                  <div className={styles.chatItemTop}>
                    <span className={`${styles.chatItemName} ${unreadCount > 0 ? styles.bold : ''}`}>
                      {chat.chatName || formatPhoneNumber(getSendTarget(chat)) || 'Contato WhatsApp'}
                    </span>
                    <span className={`${styles.chatItemTime} ${unreadCount > 0 ? styles.timeUnread : ''}`}>
                      {formatChatTimestamp(chat.date || chat.createdAt)}
                    </span>
                  </div>
                  <div className={styles.chatItemBottom}>
                    <span className={`${styles.chatItemPreview} ${unreadCount > 0 ? styles.bold : ''}`}>
                      {getChatPreview(chat)}
                    </span>
                    {unreadCount > 0 && (
                      <Badge color="primary" badgeContent={unreadCount} max={99} className={styles.unreadBadge} />
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ChatList;
